/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Medical_Technology23Inputs */

const en__field__enum_studyprograms_study_medical_technology23 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Medical_Technology23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medical Technology`)
};

const de__field__enum_studyprograms_study_medical_technology23 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Medical_Technology23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medizintechnik`)
};

/**
* | output |
* | --- |
* | "Medical Technology" |
*
* @param {_Field__Enum_Studyprograms_Study_Medical_Technology23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_medical_technology23 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Medical_Technology23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Medical_Technology23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_medical_technology23(inputs)
	return de__field__enum_studyprograms_study_medical_technology23(inputs)
});
export { _field__enum_studyprograms_study_medical_technology23 as "_field__enum_studyPrograms_STUDY_MEDICAL_TECHNOLOGY" }